import API from '../../API/endpoints';
import { API_ENDPOINT } from '../../Constants'

export const SET_DEFAULT_PLAN_IDS = 'SET_DEFAULT_PLAN_IDS';
export const SET_DEFAULT_DETAILS_LOADING = 'SET_DEFAULT_DETAILS_LOADING';
export const SET_DEFAULT_PRICES = 'SET_DEFAULT_PRICES';
export const SET_CUSTOM_PRICES = 'SET_CUSTOM_PRICES';
export const SET_CONNECT_DEVICES = "SET_CONNECT_DEVICES";
export const SET_CONTROL_DEVICES = "SET_CONTROL_DEVICES";
export const SET_LOADING_PAY = "SET_LOADING_PAY";
export const SET_SHOW_DIALOG = "SET_SHOW_DIALOG";
export const SET_SUBSCRIPTION_DETAILS = "SET_SUBSCRIPTION_DETAILS";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const SET_ALL_PRICES = 'SET_ALL_PRICES';
export const SET_SUBSCRIPTION_LOADING = 'SET_SUBSCRIPTION_LOADING'

export const setDefaultPlanIds = (payload: object) => {
    return {
        type: SET_DEFAULT_PLAN_IDS,
        payload: payload,
    }
}

export const setDefaultPrices = (payload: object) => {
    return {
        type: SET_DEFAULT_PRICES,
        payload: payload,
    }
}

export const setDefaultPlanIdsApiLoading = (payload: any) => {
    return {
        type: SET_DEFAULT_DETAILS_LOADING,
        payload: payload,
    }
}

export const setCustomPricing = (payload: any) => {
    return {
        type: SET_CUSTOM_PRICES,
        payload: payload,
    }
}

export const allPricingDetails = (payload: any) => {
    return {
        type: SET_ALL_PRICES,
        payload: payload,
    }
}

export const setConnectDevices = (payload: number) => {
    return {
        type: SET_CONNECT_DEVICES,
        payload: payload,
    }
}
export const setControlDevices = (payload: number) => {
    return {
        type: SET_CONTROL_DEVICES,
        payload: payload,
    }
}

export const setLoadingPay = (payload: boolean) => {
    return {
        type: SET_LOADING_PAY,
        payload: payload,
    }
}

export const setShowDialog = (payload: any) => {
    return {
        type: SET_SHOW_DIALOG,
        payload: payload,
    }
}

export const setSubscription = (payload: any) => {
    return {
        type: SET_SUBSCRIPTION_DETAILS,
        payload: payload,
    }
}

export const showNotification = (payload: { open: boolean, message: string, alertType: string }) => {
    return {
        type: SHOW_NOTIFICATION,
        payload: payload,
    }
}

export const setSubscriptionLoading = (payload: boolean) => {
    return {
        type: SET_SUBSCRIPTION_LOADING,
        payload: payload,
    }
}

export const getDefaultPrices = (planIds: any, history: any) => async (
    dispatch: any
) => {
    const controlPrices: any = await getPricesByProduct(planIds.control, history)
    const connectPrices: any = await getPricesByProduct(planIds.connect, history)
    if (controlPrices && connectPrices) {
        const control: any = controlPrices.find((price: any) => price.id === 'control')
        const connect: any = connectPrices.find((price: any) => price.id === 'connect')
        const controlCustom: any = controlPrices.filter((price: any) => price.id !== 'control')
        const connectCustom: any = connectPrices.filter((price: any) => price.id !== 'connect')
        dispatch(setCustomPricing({
            result: {
                control: controlCustom,
                connect: connectCustom
            }
        }))
        dispatch(setDefaultPrices({
            result: {
                control, connect
            }
        }))
        dispatch(allPricingDetails({  // To get all default & custom prices
            result: {
                control: controlPrices,
                connect: connectPrices
            }
        }))
    }
}

const getPricesByProduct = (id: any, history: any) => {
    return new Promise((resolve, reject) => {
        const reqValues = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                authorization: `Bearer ${localStorage.getItem('id_token')}`,
            },
        }

        fetch(API.prices(id), reqValues)
            .then((result) => {
                if (result.status === 403) {
                    history.push({
                        pathname: '/',
                    })
                } else {
                    return result.json()
                }
            })
            .then((result) => {
                resolve(result?.data?.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getDefaultPlanIds = ({ history }: any) => (
    dispatch: any
) => {
    const reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`,
        },
    }

    dispatch(setDefaultPlanIdsApiLoading(true))
    fetch(API.plans, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: '/',
                })
            } else {
                return result.json()
            }
        })
        .then((result) => {
            if (result) {
                dispatch(setDefaultPlanIds(result))
                dispatch(setDefaultPlanIdsApiLoading(false))
            }
        })
        .catch((error) => {
            dispatch(setDefaultPlanIdsApiLoading(false))
        })
}

export const getSubscriptionById = ({ id, history }: any) => (
    dispatch: any
) => {
    const reqValues = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            authorization: `Bearer ${localStorage.getItem('id_token')}`,
        },
    }

    const api_url = `${API_ENDPOINT}/payment/orgs/${localStorage.getItem('orgId')}/subscriptions/${id}?mode=polaris`
    dispatch(setDefaultPlanIdsApiLoading(true))
    fetch(api_url, reqValues)
        .then((result) => {
            if (result.status === 403) {
                history.push({
                    pathname: '/',
                })
            } else {
                return result.json()
            }
        })
        .then((result) => {
            if (result) {
                dispatch(setSubscription(result))
            }
            else {
                dispatch(setSubscription(result))
            }
            dispatch(setSubscriptionLoading(false))
        })
        .catch((error) => {
            // dispatch empty subscription if there is failure in getting subscription
            dispatch(setSubscription({}))
            dispatch(setSubscriptionLoading(false))
        })
}
